import UploadModel from '@/components/upload-model';
import { SIDEBAR_MENU_LINK } from '@/layouts/sidebar';
import { useAuth } from '@/provider/UserProvider';
import { Button, useDisclosure } from '@nextui-org/react';
import { useRouter, useSearchParams } from 'next/navigation';
import React, { useRef } from 'react';
import { toast } from 'react-toastify';
import { KEY_SORT } from '../constants';
import ToolbarFilter from './action';
import ToolbarSearch from './search';

const ToolBar: React.FC = () => {
  const { isOpen, onOpen, onOpenChange } = useDisclosure();
  const searchParams = useSearchParams();
  const { isLogin } = useAuth();
  const router = useRouter();
  const refSearch = useRef<any>(null);
  const handleClearFilter = () => {
    if (refSearch.current) refSearch.current.value = '';
    router.replace(SIDEBAR_MENU_LINK.aiModel, { scroll: false });
  }
  const hasQuery = !!searchParams.get(KEY_SORT.CREATED) || !!searchParams.get(KEY_SORT.LIKE) || !!searchParams.get(KEY_SORT.RUN);

  const handleAddModel = () => {
    if (!isLogin) return toast.warning('Please login to continue!');
    onOpen();
  }

  return (
    <div className="flex items-center justify-between sm:flex-wrap">
      <div className="flex items-center sm:w-full">
        <ToolbarFilter />
        {hasQuery && (
          <Button
            className="ml-2 rounded-full border-1 border-gray-200 bg-white text-[14px] h-10 w-10 sm:h-[36px] sm:w-[36px] font-medium"
            onClick={handleClearFilter}
          >
            Clear all
          </Button>
        )}
        <div aria-checked={hasQuery} className="ml-2 sm:w-[calc(100%-44px)] aria-checked:sm:w-[calc(100%-44px-88px)]">
          <ToolbarSearch refSearch={refSearch} />
        </div>
      </div>
      <Button onClick={handleAddModel} className="rounded-full sm:hidden bg-primary text-[14px] h-10 sm:h-[36px] text-white">
        <span className="text-[22px] font-light">+</span> 
        <span className="font-medium">Add Model</span>
      </Button>
      <UploadModel isOpen={isOpen} onOpenChange={onOpenChange} />
    </div>
  );
}

export default ToolBar;